import { useTranslation } from 'react-i18next';

import { GraphChartConfigDto, LineChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useLineChartData } from 'hooks/useLineChartData';
import LineChart from 'components/Charts/LineChart/LineChart';

const ReportLineChart = ({ chartData, isLoading, chartConfig }: ChartProps<LineChartDataDto, GraphChartConfigDto>) => {
  const { t } = useTranslation();

  const chartDataDisplay = useLineChartData(chartData?.datasets, isLoading);

  return <LineChart xLabel={''} yLabel={t(chartConfig.yAxis)} chartData={chartDataDisplay} xStepFormat='integer' />;
};

export default ReportLineChart;
